import React from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from '@/components/Icons/Info';

export const NextStudyYearBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2 rounded-xl border border-warning bg-destructive-surface p-4">
      <div className="inline-flex w-fit items-center gap-1 rounded-xl bg-warning-surface py-[2px] pr-2 pl-1 text-caption-12 text-warning">
        <Info className="size-4 shrink-0" />
        {t('profile.nextYearBanner.label')}
      </div>
      <p className="text-body-14 text-muted-foreground">
        {t('profile.nextYearBanner.description')}
      </p>
    </div>
  );
};
